import ToastNotification from "../utils/ToastNotification";

export default class ConfigurationGroupManager {
    constructor() {
        this.currentGroupId = null;
        this.bindEvents();
        this.loadGroups();
        this.setDefaultExpirationDate();
    }

    bindEvents() {
        let self = this;

        $("#group_form").unbind("submit").submit(function (e) {
            e.preventDefault();
            self.saveGroup();
        });

        $("#cancel_group").unbind("click").click(function (e) {
            e.preventDefault();
            self.cancelEdit();
        });
    }

    setDefaultExpirationDate() {
        if (!$("#group_expired_at").val()) {
            const threeMonthsFromNow = new Date();
            threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
            const formatted = threeMonthsFromNow.toISOString().slice(0, 16);
            $("#group_expired_at").val(formatted);
        }
    }

    loadGroups() {
        let self = this;
        const locale = window.data?.locale || 'en';

        $.ajax({
            url: `/${locale}/configuration/ajax_groups`,
            method: "GET",
        }).done(function (html) {
            self.renderGroups(html);
        }).fail(function (err) {
            ToastNotification.make(I18n.t("website.errors.generic"));
        });
    }

    renderGroups(html) {
        const groupsList = $("#groups_list");
        const self = this;
        groupsList.empty();

        if (!html || html.trim() === '') {
            groupsList.append(`
                <tr>
                    <td colspan="6" class="text-center text-muted py-4">
                        ${I18n.t("website.group.no_groups")}
                    </td>
                </tr>
            `);
        } else {
            groupsList.html(html);
        }

        // Bind edit buttons
        $(".edit-group").unbind("click").click(function () {
            const groupData = {
                id: $(this).data("group-id"),
                name: $(this).data("group-name"),
                category_id: $(this).data("group-category-id"),
                expired_at: $(this).data("group-expired-at"),
                privacy_type: $(this).data("group-privacy-type")
            };
            self.editGroup(groupData);
        });

        // Bind delete buttons
        $(".delete-group").unbind("click").click(function () {
            const groupId = $(this).data("group-id");
            const groupName = $(this).data("group-name");
            self.deleteGroup(groupId, groupName);
        });
    }

    editGroup(group) {
        this.currentGroupId = group.id;
        $("#group_id").val(group.id);
        $("#group_name").val(group.name);

        // For select2 dropdowns, need to trigger change event
        $("#group_category_id").val(group.category_id).trigger('change');

        if (group.expired_at) {
            const date = new Date(group.expired_at);
            $("#group_expired_at").val(date.toISOString().slice(0, 16));
        } else {
            $("#group_expired_at").val("");
        }

        $("#group_privacy_type").val(group.privacy_type);
        $("#cancel_group").show();

        // Scroll to form
        $('html, body').animate({
            scrollTop: $("#group_form").offset().top - 100
        }, 500);
    }

    cancelEdit() {
        this.currentGroupId = null;
        $("#group_form")[0].reset();
        $("#group_id").val("");
        // Reset select2 to first option
        $("#group_category_id").val($("#group_category_id option:first").val()).trigger('change');
        $("#cancel_group").hide();
        this.setDefaultExpirationDate();
    }

    saveGroup() {
        let self = this;
        const groupId = this.currentGroupId;
        const isUpdate = groupId !== null;

        const data = {
            group: {
                name: $("#group_name").val(),
                category_id: parseInt($("#group_category_id").val()),
                expired_at: $("#group_expired_at").val() || null,
                privacy_type: parseInt($("#group_privacy_type").val())
            }
        };

        let ajaxData = {
            url: window.application.getAPIUrl() + (isUpdate ? `/v1/group/${groupId}` : "/v1/group"),
            data: data,
            method: isUpdate ? "PUT" : "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
            },
        };

        $.ajax(ajaxData).done(function (response) {
            ToastNotification.make(I18n.t(isUpdate ? "website.group.updated" : "website.group.created"));
            self.cancelEdit();
            self.loadGroups();
        }).fail(function (err) {
            const message = err.responseJSON?.errors?.join("<br>") || I18n.t("website.errors.generic");
            ToastNotification.make(message);
        });
    }

    deleteGroup(groupId, groupName) {
        if (!confirm(I18n.t("website.group.delete_confirm"))) {
            return;
        }

        let self = this;
        let ajaxData = {
            url: window.application.getAPIUrl() + `/v1/group/${groupId}`,
            method: "DELETE",
            beforeSend: function (request) {
                request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
            },
        };

        $.ajax(ajaxData).done(function (response) {
            ToastNotification.make(I18n.t("website.group.deleted"));
            self.loadGroups();
        }).fail(function (err) {
            const message = err.responseJSON?.errors?.join("<br>") || I18n.t("website.errors.generic");
            ToastNotification.make(message);
        });
    }

    onDataChanged(data) {
        // No specific action needed on data change
    }

    onDestroy() {
        $("#group_form").unbind("submit");
        $("#cancel_group").unbind("click");
        $(".edit-group").unbind("click");
        $(".delete-group").unbind("click");
    }
}
